"use strict";import{tag as o}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const TextBoldIcon=({width:t=24,height:e=24,hidden:l=!1,title:r="Text Bold"}={})=>o`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${t}"
    height="${e}"
    viewBox="0 0 20 20"
    aria-hidden=${l?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
  >
    <path
      d="m13.98926,2.01465H5.51074c-1.38477,0-2.51074,1.17773-2.51074,2.625v1.11035c0,.62109.50391,1.125,1.125,1.125s1.125-.50391,1.125-1.125v-1.11035c0-.2207.1377-.375.26074-.375h2.48926v11.44531c0,.00488.00146.00977.00146.01465h-.57178c-.62109,0-1.125.50391-1.125,1.125s.50391,1.125,1.125,1.125h4.64062c.62109,0,1.125-.50391,1.125-1.125s-.50391-1.125-1.125-1.125h-.57178c0-.00488.00146-.00977.00146-.01465V4.26465h2.48926c.12305,0,.26074.1543.26074.375v1.11035c0,.62109.50391,1.125,1.125,1.125s1.125-.50391,1.125-1.125v-1.11035c0-1.44727-1.12598-2.625-2.51074-2.625Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
//# sourceMappingURL=TextBold.js.map
